<tt-page>
    <tt-page-heading></tt-page-heading>
    <div class="flex-1" style="display: flex; gap: 0.5rem">
        <div class="flex-column col-xs-12 sp-0 col-md-3">
            <tt-card>
                <tt-input #filter ttLabel="filter" ttShowClearButton></tt-input>
                <!-- *ngIf="!(['mobile', 'tablet'] | mediaQuery)" -->
                <tt-button-goto
                    ttText="add_new_usergroup"
                    ttIcon="far fa-plus"
                    [ttGoto]="(['mobile', 'tablet'] | mediaQuery) ? 'usergroupedit' : ''"
                    [ttGotoParms]="{ usergroup_keyno: 0 }"
                    (ttClick)="userGroup.setCurrentUserGroup({ usergroup_keyno: 0 })"
                ></tt-button-goto>
                <!-- <tt-button-goto
                    *ngIf="['mobile', 'tablet'] | mediaQuery"
                    ttText="add_new_usergroup"
                    ttIcon="far fa-plus"
                    ttGoto="usergroupedit"
                    [ttGotoParms]="{ usergroup_keyno: 0 }"
                ></tt-button-goto> -->
            </tt-card>
            <tt-list
                class="flex-1"
                [ttRadioSelection]="!(['mobile', 'tablet'] | mediaQuery)"
                [(ttSelectedId)]="selectedUserGroup"
                [ttFilter]="filter.ttModel"
                [(ttData)]="userGroups"
                (ttRadioSelectionChanged)="userGroup.setCurrentUserGroup({ usergroup_keyno: $event.item_id })"
                ttHeightFull
                [ttGoto]="['mobile', 'tablet'] | mediaQuery"
            ></tt-list>
        </div>
        <tt-user-group *ngIf="!(['mobile', 'tablet'] | mediaQuery)" (submit)="onSubmit($event)"></tt-user-group>
    </div>
</tt-page>
